import { InternalLink } from '../../../../../components/Clickables/InternalLink/InternalLink';
import { ChevronRightIcon } from '../../../../../components/Icons/ChevronRightIcon';
import { ISEOWaterObj } from '../../../../../constants/fishingWaters/constants';
import { getFishingWaterUrl } from '../../../../../helpers/urls';

interface MostPopularFishingLocationProps {
  water: ISEOWaterObj;
  index: number;
  isHidden: boolean;
}
export const MostPopularFishingLocationCard = ({
  water,
  index,
  isHidden,
}: MostPopularFishingLocationProps) => {
  const name = water.locationName;
  const externalId = water.fishingWaterId;
  return (
    <InternalLink
      to={getFishingWaterUrl(externalId, name)}
      data-testid="MostPopularFishingLocationCard"
      className={`${isHidden ? 'hidden' : ''} col-span-4 flex justify-between rounded-lg border border-none bg-white py-1.5 pl-3 pr-1 sm:col-span-6 md:col-span-4 lg:col-span-3`}
    >
      <span className="flex items-center justify-between gap-3 font-semibold">
        <span className="flex size-10 items-center justify-center rounded-full border border-twilight">
          {index + 1}
        </span>
        <span className="flex flex-col">
          <span>
            {water.locationName}
            {water.region && `, ${water.region}`}
          </span>
        </span>
      </span>
      <span className="flex items-center">
        <ChevronRightIcon />
      </span>
    </InternalLink>
  );
};
